import { useEffect, useState } from 'react';

const useGetHost = () => {
  const [host, setHost] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHost(window.location.hostname);
    }
  }, []);

  return host;
};

export default useGetHost;
